import { useEffect } from 'react'
import { useAppStore } from '@/store'

export function useGlobalShortcuts() {
  const {
    commandPaletteOpen,
    threadPanelOpen,
    searchOpen,
    inboxOpen,
    pinnedOpen,
    emojiPickerOpen,
    keyboardShortcutsOpen,
    connectionStatus,
    toggleCommandPalette,
    setCommandPaletteOpen,
    toggleSearch,
    toggleMemberSidebar,
    setEmojiPickerOpen,
    toggleInbox,
    togglePinned,
    closeThread,
    setConnectionStatus,
    toggleKeyboardShortcuts,
    setKeyboardShortcutsOpen,
  } = useAppStore()

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      // Cmd+K — command palette
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault()
        toggleCommandPalette()
      }

      // Cmd+F — search
      if ((e.metaKey || e.ctrlKey) && e.key === 'f') {
        e.preventDefault()
        toggleSearch()
      }

      // Cmd+Shift+M — toggle member sidebar
      if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.key === 'M') {
        e.preventDefault()
        toggleMemberSidebar()
      }

      // Ctrl+Shift+D — cycle connection status (demo)
      if ((e.metaKey || e.ctrlKey) && e.shiftKey && e.key === 'D') {
        e.preventDefault()
        const cycle: Array<'connected' | 'connecting' | 'reconnecting' | 'offline'> = ['connected', 'connecting', 'reconnecting', 'offline']
        const idx = cycle.indexOf(connectionStatus)
        setConnectionStatus(cycle[(idx + 1) % cycle.length])
        return
      }

      // ? — keyboard shortcuts (when not in input/textarea)
      if (e.key === '?' && !(e.target instanceof HTMLInputElement) && !(e.target instanceof HTMLTextAreaElement)) {
        e.preventDefault()
        toggleKeyboardShortcuts()
        return
      }

      // Escape — close topmost panel (one at a time, priority order)
      if (e.key === 'Escape') {
        if (keyboardShortcutsOpen) {
          setKeyboardShortcutsOpen(false)
          return
        }
        if (searchOpen) {
          toggleSearch()
        } else if (inboxOpen) {
          toggleInbox()
        } else if (pinnedOpen) {
          togglePinned()
        } else if (emojiPickerOpen) {
          setEmojiPickerOpen(false)
        } else if (threadPanelOpen) {
          closeThread()
        } else if (commandPaletteOpen) {
          setCommandPaletteOpen(false)
        }
      }
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [
    commandPaletteOpen,
    threadPanelOpen,
    searchOpen,
    inboxOpen,
    pinnedOpen,
    emojiPickerOpen,
    keyboardShortcutsOpen,
    connectionStatus,
    toggleCommandPalette,
    setCommandPaletteOpen,
    toggleSearch,
    toggleMemberSidebar,
    setEmojiPickerOpen,
    toggleInbox,
    togglePinned,
    closeThread,
    setConnectionStatus,
    toggleKeyboardShortcuts,
    setKeyboardShortcutsOpen,
  ])
}
